import { MouseEvent } from "react";

/** Fake href for gated CAT anchors — a real URL would let middle-click / open-in-new-tab bypass the modal. */
export const CAT_GATED_HREF = "#";

export const catGatedOpenLinkClassName =
  "cursor-pointer select-none text-base text-ribbon-500 outline-ribbon-300 hover:underline dark:text-ribbon-400";

export const catGatedDisabledLinkClassName =
  "pointer-events-none select-none text-base text-gray-400 outline-none dark:text-gray-500";

/** Primary left-click or middle-click that should open a gated CAT link. */
export function isCatGatedOpenGesture(event: MouseEvent): boolean {
  const isPrimaryClick = event.type === "click" && event.button === 0;
  const isMiddleClick = event.type === "auxclick" && event.button === 1;
  return isPrimaryClick || isMiddleClick;
}

/**
 * Intercepts click/auxclick on a gated CAT anchor: preventDefault then run `open`.
 * Ignores other buttons so context-menu / non-primary clicks stay untouched.
 */
export function handleCatGatedAnchorOpen(event: MouseEvent<HTMLAnchorElement>, open: () => void): void {
  if (!isCatGatedOpenGesture(event)) {
    return;
  }
  event.preventDefault();
  open();
}
